import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { WorkflowGoogleDriveFileContextDto } from '@/api/generated';

interface GoogleDriveActions {
  openGoogleDrive: () => void;
  closeGoogleDrive: () => void;
  setSelectedGoogleDriveFiles: (files: WorkflowGoogleDriveFileContextDto[]) => void;
  clearSelectedGoogleDriveFiles: () => void;
}
interface GoogleDriveStore {
  isGoogleDriveOpen: boolean;
  selectedGoogleDriveFiles: WorkflowGoogleDriveFileContextDto[];
  actions: GoogleDriveActions;
}

const useGoogleDriveStore = create<GoogleDriveStore>()(
  devtools(set => ({
    isGoogleDriveOpen: false,
    selectedGoogleDriveFiles: [],
    actions: {
      openGoogleDrive: () => set({ isGoogleDriveOpen: true }),
      closeGoogleDrive: () => set({ isGoogleDriveOpen: false }),
      setSelectedGoogleDriveFiles: (files: WorkflowGoogleDriveFileContextDto[]) =>
        set({ selectedGoogleDriveFiles: files }),
      clearSelectedGoogleDriveFiles: () => set({ selectedGoogleDriveFiles: [] })
    }
  }))
);

export const useIsGoogleDriveOpen = () => useGoogleDriveStore(state => state.isGoogleDriveOpen);
export const useGoogleDriveActions = () => useGoogleDriveStore(state => state.actions);
export const useSelectedGoogleDriveFiles = () =>
  useGoogleDriveStore(state => state.selectedGoogleDriveFiles);
